export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4858.ec7aaf20.jpg";